import React, { useRef } from 'react'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useDrag, useDrop } from 'react-dnd'
import { PropTypes } from 'prop-types'
import MenuIcon from '@mui/icons-material/Menu'
import config from '../../config/config'
import { getIcon } from './CustomSlider'
import { SubSectionTitle } from './ProjectInputs'
const style = {
  borderBottom: '1px solid gray',
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',

  cursor: 'move',
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  width: '100%',
  backgroundColor: 'white'
}
export const Card = ({
  id,
  text,
  index,
  moveCard,
  tier,
  shareableURL,
  modalTier
}) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex, tier, shareableURL)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    }
  })
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  })
  const opacity = isDragging ? 0 : 1
  // drag(drop(ref))
  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          width: '5%',
          alignSelf: 'center',
          fontSize: '22px',
          marginBottom: '.5rem'
        }}
      >
        <Typography variant="body">{index + 1}</Typography>
      </div>
      <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
        {/* <Box>
          <MenuIcon sx={{ color: config.themeConfig.semcogLightGray }} />
        </Box> */}
        <Box>
          <img src={getIcon(tier)} style={{ width: '30px', height: '30px' }} />
        </Box>
        <Box
          sx={{
            borderRadius: '2px',
            padding: '0.25rem 0.75rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'black'
          }}
        >
          <SubSectionTitle fontSize={11.375} color="white" fontWeight={900}>
            {modalTier === 0 ? 'N/A' : modalTier}
          </SubSectionTitle>
        </Box>
        <SubSectionTitle fontSize={16}>{text}</SubSectionTitle>
      </div>
    </div>
  )
}
Card.propTypes = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  moveCard: PropTypes.func.isRequired,
  tier: PropTypes.string.isRequired,
  shareableURL: PropTypes.bool.isRequired,
  modalTier: PropTypes.number.isRequired
}
